import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import IModal from '@/js/components/molecules/IModal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CartModal',
  props: {
    text: { default: 'カートに追加されました' }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;
const onOk = () => {
  window.location.href = '/cart';
};
const onCancel = () => {
  emit('close');
};
const onClose = () => {
  emit('close');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IModal, {
    id: "cart-modal",
    "text-cancel": "買い物を続ける",
    "text-ok": "カートに進む",
    "with-action-button": true,
    class: _normalizeClass(_ctx.$style.modal),
    onCancel: onCancel,
    onOk: onOk,
    onClose: onClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.$style.text)
      }, _toDisplayString(_ctx.text), 3)
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})